<template>
    <Baidu v-if="isbaidu" />
    <Header v-else />
    <router-view></router-view>
</template>

<script setup>
import Header from "./components/header.vue";
import Baidu from "./components/baidu.vue";
import { ref, onMounted } from "vue";

const isbaidu = ref(false);
</script>

<style lang="scss" scoped></style>
